var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-picker',{attrs:{"type":_vm.type},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }